import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  collectionTypes: [],
  editableCollectionTypes: [],
  isEditing: false,
  isDirty: false,
  isLoading: false,
  isLocked: false,
  lockedBy: "",
};

export const collectionTypesSlice = createSlice({
  name: "collectionTypes",
  initialState,
  reducers: {
    setCollectionTypes(state, { payload = [] }) {
      state.collectionTypes = payload;
    },
    setEditableCollectionTypes(state, { payload = [] }) {
      state.editableCollectionTypes = payload;
    },
    addType(state, { payload }) {
      const { type, index } = payload;
      state.isDirty = true;
      state.editableCollectionTypes = [
        ...state.editableCollectionTypes.slice(0, index + 1),
        type,
        ...state.editableCollectionTypes.slice(index + 1),
      ];
    },
    updateType(state, { payload = {} }) {
      const { type, index } = payload;
      state.isDirty = true;
      state.editableCollectionTypes = state.editableCollectionTypes.map(
        (item, i) => (i === index ? { ...item, ...type } : item)
      );
    },
    removeType(state, action) {
      const index = action.payload;
      state.isDirty = true;
      state.editableCollectionTypes = state.editableCollectionTypes.filter(
        (_, i) => i !== index
      );
    },
    setIsEditing(state, { payload }) {
      state.isEditing = Boolean(payload);
    },
    setIsDirty(state, { payload }) {
      state.isDirty = Boolean(payload);
    },
    setIsLoading(state, { payload }) {
      state.isLoading = Boolean(payload);
    },
    setIsLocked(state, { payload }) {
      state.isLocked = Boolean(payload);
    },
    setLockedBy(state, { payload }) {
      state.lockedBy = payload;
    },
  },
});

export const {
  setCollectionTypes,
  setEditableCollectionTypes,
  addType,
  updateType,
  removeType,
  setIsEditing,
  setIsDirty,
  setIsLoading,
  setIsLocked,
  setLockedBy,
} = collectionTypesSlice.actions;

export default collectionTypesSlice.reducer;
